import { Link } from "react-router-dom";
import { CONTACT_EMAIL } from "@/data/legal";

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-white/10 bg-[#050505]" data-testid="site-footer">
    <div className="mx-auto max-w-6xl px-6 pb-10 pt-16 sm:pt-24">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-6">
          <img src="/assets/logo.png" alt="JomKonvoi logo" className="h-20 w-auto" data-testid="footer-logo" />
          <p className="label-tech mt-4 text-[#FF3333]">JomKonvoi</p>
          <p className="mt-4 max-w-sm font-display text-2xl font-bold leading-snug text-white">
            Ride together, arrive together.
          </p>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-neutral-400">
            The group-ride companion that keeps car and motorcycle convoys connected — live positions, regroup
            alerts, one shared route.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="label-tech text-neutral-500">Legal Center</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li>
              <Link to="/legal" className="text-neutral-300 transition-colors duration-300 hover:text-white" data-testid="footer-legal-center-link">
                Legal Center
              </Link>
            </li>
            <li>
              <Link to="/legal/privacy" className="text-neutral-300 transition-colors duration-300 hover:text-white" data-testid="footer-privacy-link">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/legal/terms" className="text-neutral-300 transition-colors duration-300 hover:text-white" data-testid="footer-terms-link">
                Terms of Service
              </Link>
            </li>
            <li>
              <Link to="/legal/safety" className="text-neutral-300 transition-colors duration-300 hover:text-white" data-testid="footer-safety-link">
                Safety Guidelines
              </Link>
            </li>
            <li>
              <Link to="/manage-data" className="text-neutral-300 transition-colors duration-300 hover:text-white" data-testid="footer-manage-data-link">
                Manage My Data
              </Link>
            </li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="label-tech text-neutral-500">Contact</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li>
              <a href={`mailto:${CONTACT_EMAIL}`} className="text-neutral-300 transition-colors duration-300 hover:text-white" data-testid="footer-contact-email">
                {CONTACT_EMAIL}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-16 select-none overflow-hidden" aria-hidden="true">
        <p className="text-outline whitespace-nowrap text-center font-display text-[13vw] font-black leading-none tracking-tighter">
          JOMKONVOI
        </p>
      </div>
      <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-neutral-500 sm:flex-row">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} JomKonvoi. All rights reserved.</p>
        <p>Built for the crews who never ride alone.</p>
      </div>
    </div>
  </footer>
);
